// React
import React, { useState, useEffect } from 'react';

// Material UI
import Paper from '@material-ui/core/Paper';
import EventIcon from '@material-ui/icons/Event';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

// Redux
import { useSelector } from 'react-redux';
import { RootStore } from '../../../Store';

// Translations
import { useTranslation } from 'react-i18next';

// Components
import PreordersFilters from './PreordersFilters';
import PreordersRow from './PreordersRow';
import PreorderEventOrdersList from './PreorderEventOrdersList';

// Styles
import useStyles from './PreordersListStyles';

const PreordersList: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('global');
  const preorderEventState = useSelector((state: RootStore) => state.preorderEvents);
  const { loading, preorderEventList } = preorderEventState;

  const [hasSearched, setHasSearched] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);

  // Check if we were navigated here with an eventId in history state
  useEffect(() => {
    const state = window.history.state?.state;
    if (state?.eventId) {
      setSelectedEventId(state.eventId);
    }
  }, []);

  const handleSearch = () => {
    setHasSearched(true);
  };

  const handleClear = () => {
    setHasSearched(false);
    setSelectedEventId(null);
  };

  const handleSelectEvent = (eventId: number) => {
    setSelectedEventId(eventId);
  };

  return (
    <div className={classes.root}>
      {!selectedEventId && (
        <PreordersFilters onSearch={handleSearch} onClear={handleClear} />
      )}
      <Paper elevation={3}>
        <div className={classes.boxTop}>
          <EventIcon color="primary" fontSize="large" />
          <Typography variant="h5" color="primary" className={classes.sectionTitle}>
            {t('nav.preorders')} {hasSearched && `(${preorderEventList?.totalElements || 0} ${t('preorders.results')})`}
          </Typography>
          {loading === 'GET_PREORDER_EVENTS' && <CircularProgress size={26} color="primary" />}
        </div>
        {!selectedEventId && (
          <PreordersRow hasSearched={hasSearched} onSelectEvent={handleSelectEvent} />
        )}
        {selectedEventId && (
          <PreorderEventOrdersList preorderEventId={selectedEventId} onClearSelection={() => setSelectedEventId(null)} />
        )}
      </Paper>
    </div>
  );
};

export default PreordersList;
